module.exports = __webpack_public_path__ + "static/media/runway_designers.cc39dd86.jpg";